// contract.keys.ts
import type { GetContractsParams } from './types';

export const contractKeys = {
  all: ['contracts'] as const,
  list: (filters?: GetContractsParams) => [...contractKeys.all, 'list', filters] as const,
  detail: (id: string) => [...contractKeys.all, 'detail', id] as const,
};
